const BillingShippingTab = () => {
  return <>Billing & Shipping Address</>;
};

export default BillingShippingTab;
